enum MarketCoverageTypeEnum {
  Individual = "Individual",
  Shop = "SHOP (Small Group)",
}

export { MarketCoverageTypeEnum };
